import { Stack } from '@mui/material'
import { PLAN_TARGET_VIEWER_OPTIONS } from '@editor/pages/PlanView/constants'
import { FormControlledSwitchLabeled, Select, TextField, UnitConvertedField } from '@ui/forms'

const paperFormatOptions = [
  {
    value: 'A3',
    label: 'A3',
  },
  {
    value: 'A2',
    label: 'A2',
  },
  {
    value: 'A1',
    label: 'A1',
  },
]

const paperOrientationOptions = [
  {
    value: 'landscape',
    label: 'Quer',
  },
  {
    value: 'portrait',
    label: 'Hochkant',
  },
]

const FormFields = () => {
  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        <Select
          label="Format"
          name="paperFormat"
          options={paperFormatOptions}
          data-cy="export-settings-format-select"
        />
        <Select
          label="Quer / Hoch"
          name="orientation"
          options={paperOrientationOptions}
          data-cy="export-settings-orientation-selection"
        />
        <TextField name="scale" label="Maßstab 1:X" type="number" placeholder="Maßstab 1:X" />
        <TextField name="fontSize" label="Schriftgr." type="number" placeholder="Schriftgr." />
      </Stack>

      <Stack direction="row" spacing={1}>
        <UnitConvertedField
          name="user_defined_origin.x"
          type="number"
          inputLabel="Position x von links"
          placeholder="x"
          unitLabel="cm"
          conversionFactor={1 / 100}
        />
        <UnitConvertedField
          name="user_defined_origin.y"
          type="number"
          inputLabel="Position y von unten"
          placeholder="y"
          unitLabel="cm"
          conversionFactor={1 / 100}
        />
      </Stack>

      <Select
        inputLabel="Optimiert für"
        name="targetViewer"
        options={[...PLAN_TARGET_VIEWER_OPTIONS]}
        data-cy="export-settings-target-viewer-select"
      />

      <FormControlledSwitchLabeled
        name="showShearAnchorCount"
        label="Anzahl Schubanker ausgeben"
        tooltip={{
          headline: 'Anzahl Schubanker ausgeben',
          text: 'Wenn aktiviert, steht im Aussteifungsplan vor jeder Schubanker-Bezeichnung, wie viele Schubanker das Segment benötigt (z. B. „3x SA1“): Segmentlänge geteilt durch den Abstand des Schubankers, aufgerundet.',
        }}
        data-cy="export-settings-show-shear-anchor-count-switch"
      />
    </Stack>
  )
}

export default FormFields
